// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1NPtC","inputWrap":"styles_inputWrap__1S4kp","input":"styles_input__3_P4t"};